import { render } from "./OrderContent.vue?vue&type=template&id=3a329ee4&scoped=true"
import script from "./OrderContent.vue?vue&type=script&lang=js"
export * from "./OrderContent.vue?vue&type=script&lang=js"

import "./OrderContent.vue?vue&type=style&index=0&id=3a329ee4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a329ee4"]])

export default __exports__